import React, { Component } from 'react'
import Title from '../components/Title'
import {FaHiking,FaBeer,FaCocktail,FaShuttleVan} from 'react-icons/fa'
export default class Services extends Component {
    state = {
        services : [
            {
                icon : <FaHiking />,
                title : 'free Hiking',
                info : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid, odio eos ea error incidunt facilis accusantium laboriosam harum inventore illo vero ipsam omnis, sapiente fugit. Necessitatibus iste labore nisi laborum!'
            },
            {
                icon : <FaCocktail />,
                title : 'free Cocktail',
                info : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid, odio eos ea error incidunt facilis accusantium laboriosam harum inventore illo vero ipsam omnis, sapiente fugit. Necessitatibus iste labore nisi laborum!'
            },
            {
                icon : <FaShuttleVan />,
                title : 'free ShuttleVan',
                info : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid, odio eos ea error incidunt facilis accusantium laboriosam harum inventore illo vero ipsam omnis, sapiente fugit. Necessitatibus iste labore nisi laborum!'
            },
            {
                icon : <FaBeer />,
                title : 'free Beer',
                info : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid, odio eos ea error incidunt facilis accusantium laboriosam harum inventore illo vero ipsam omnis, sapiente fugit. Necessitatibus iste labore nisi laborum!'
            },
        ]
    }
    render() {
        return (
            <section className="services">
                <Title title="Services" />
                <div className="services-center">
                    {this.state.services.map((service,index) => {
                        return <article className="service" key={index}>
                                    <span>{service.icon}</span>
                                    <h6>{service.title}</h6>
                                    <p>{service.info}</p>
                                </article>
                    })}
                </div>
            </section>
            
        )
    }
}
